import { AdminOnlyItemRestraints } from '@core/shared/restraints';
export class DemoRequestRestraints extends AdminOnlyItemRestraints {
  canCreateItem(item) {
    return true;
  }
}